/**
 * Build searchable text from a session row (club + session fields).
 */
export function getSessionSearchHaystack(session) {
  return [
    session.name,
    session.description,
    session.location,
    session.clubs?.name,
    session.clubs?.location,
    session.session_types?.name,
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
}

/**
 * Case-insensitive keyword match — every word in the query must appear somewhere.
 */
export function sessionMatchesSearchQuery(session, query) {
  const trimmed = query.trim().toLowerCase();
  if (!trimmed) return true;

  const haystack = getSessionSearchHaystack(session);
  return trimmed.split(/\s+/).every((token) => haystack.includes(token));
}
